// Find the true event root.
export const getEventRoot = (slug: string): string | null => {
  if (!slug) {
    return null;
  }

  const paths = slug.split('/').filter((path) => !!path);

  // Accommodate special pages like login
  if (paths[0] === 'login?page=' || paths[0] === 'login?page=#') {
    paths.shift();
  }

  // Ignore trailing # if present.
  if (paths[0] === '#') {
    paths.shift();
  }

  const [conference, event] = paths;

  return `${conference}/${event}`;
};

export const componentHide = ({ hiddenIds, componentId }: { hiddenIds: string[]; componentId: string }): boolean => {
  return !hiddenIds?.includes(componentId);
};

export const sanitiseUrl = (url: string): any | null => {
  if (!url) {
    return null;
  }
  const urlArr = url.split('/').filter((segment) => segment !== '#' && segment);
  // Clean url
  for (let i = 0; i < urlArr.length; i++) {
    if (urlArr[i] !== undefined) {
      if (urlArr[i].includes('localhost:3000')) {
        urlArr.splice(i, 1);
        i--;
      } else if (urlArr[i].includes('http')) {
        // Remove http(s)
        urlArr.splice(i, 1);
        i--;
        // Remove digitalaccess-events.com/
        urlArr.splice(i + 1, 1);
        i--;
      }
    }
  }

  let pageTitle = urlArr[urlArr.length - 1];
  if (pageTitle && urlArr[0].includes('login')) {
    pageTitle = urlArr[0];
  }
  // Clean pageTitle.
  if (pageTitle?.includes('?')) {
    pageTitle = pageTitle.substring(0, pageTitle.indexOf('?'));
  }

  return { pagePath: urlArr.join('/'), pageTitle };
};

export const getSlug = (aspath) => {
  let path: any = aspath.split('#');
  path = path.length > 1 ? path[1] : path[0];
  const [, conferenceSlug, eventSlug] = path.split('/');
  return `${conferenceSlug}/${eventSlug}`;
};
